import { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  TextField,
  Grid,
  Typography,
  Select,
  MenuItem,
} from "../../../../../components";
import { notification, NfseService } from "../../../../../services";
import { responseErros } from "../../../../../utils";
import NfseCancelamento from "../../entities/nfse-cancelamento.entity";

const CancelamentoDialog = ({ open, setOpen, setLoading, id, buscarNfse }) => {
  const [justificativa, setJustificativa] = useState(null);
  const [tipoCancelamento, setTipoCancelamento] = useState("");
  const nfseService = new NfseService();

  const onSubmit = (event) => {
    event.preventDefault();
    validarCancelamento();
  };

  const validarCancelamento = async () => {
    if (!tipoCancelamento) {
      notification.erroGenerico("Selecione o tipo de cancelamento");
      return;
    }
    if (!justificativa || justificativa.length < 15) {
      notification.erroGenerico("Justificativa deve ter ao menos 15 caracteres");
      return;
    }
    await cancelarNfse();
  };

  const cancelarNfse = async () => {
    setLoading(true);
    const nfseCancelamento = new NfseCancelamento(justificativa, tipoCancelamento);
    const response = await nfseService.cancelar(id, nfseCancelamento);
    setLoading(false);
    if (!response.isAxiosError) {
      notification.alteracaoSucesso();
      await buscarNfse();
      setOpen(false);
      return;
    }
    if (response.status != 400) {
      responseErros(response);
    }
  };

  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <form onSubmit={(event) => onSubmit(event)}>
        <DialogContent>
          <CardHeader title="Cancelar NFS-e" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Select
                  id="tipoCancelamento"
                  name="tipoCancelamento"
                  label="Tipo de cancelamento"
                  variant="outlined"
                  fullWidth
                  value={tipoCancelamento}
                  onChange={(e) => setTipoCancelamento(e.target.value)}
                >
                  <MenuItem value={"IssuedWithError"}>Erro de emissão</MenuItem>
                  <MenuItem value={"ServiceNotProvided"}>Serviço não prestado</MenuItem>
                  <MenuItem value={"Other"}>Outros</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="justificativa"
                  name="justificativa"
                  label="Justificativa"
                  variant="outlined"
                  margin="normal"
                  onChange={(event) => setJustificativa(event.target.value)}
                  value={justificativa}
                  required
                  fullWidth
                />
                <Grid item xs={12} className="d-flex justify-content-between">
                  <Typography style={{ color: "#DC3545" }}>
                    Quantidade mínima de 15 caracteres
                  </Typography>
                  <Typography>
                    N° de caracteres: {justificativa?.length || 0}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button variant="contained" color="primary" type="submit">
              <i
                className="ph-fill ph-check-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Cancelar NFS-e
            </Button>
            <Button
              variant="contained"
              color="padrao"
              onClick={() => setOpen(false)}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Fechar
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default CancelamentoDialog;
